import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AcknowledgeDialogComponent } from '../../pages/acknowledge-dialog/acknowledge-dialog.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-landing-layouts',
  templateUrl: './landing-layouts.component.html',
  styleUrls: ['./landing-layouts.component.scss']
})
export class LandingLayoutsComponent implements OnInit {
  private currentUrl = '';

  constructor(private router: Router, private route: ActivatedRoute, private dialog: MatDialog) {
    this.currentUrl = this.router.url || '';
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(e => {
      this.currentUrl = e.urlAfterRedirects || e.url || '';
    });
  }

  ngOnInit(): void {
    this.checkEmailVerify();
  }

  isRootPath(): boolean {
    return /^\/(#.*)?$/.test(this.router.url);
  }

  hasProductSubnav(): boolean {
    const url = this.currentUrl || this.router.url || '';
    const path = url.split('?')[0].split('#')[0];
    return (
      path.startsWith('/landing-ntrip-caster') ||
      path.startsWith('/landing-rtk-base-analyzer') ||
      path.startsWith('/landing-ppk-downloader') ||
      path.startsWith('/geoastra-gnss-receivers') ||
      path.startsWith('/geoastra-software')
    );
  }

  checkEmailVerify(): void {
    this.route.queryParams.subscribe(params => {
      const error = params['error'];
      const errorDescription = params['error_description'];

      if (error === 'access_denied' && errorDescription === 'Please verify your email before logging in.') {
        this.dialog.open(AcknowledgeDialogComponent, {
          data: 'Please proceed to your mailbox to verify your email. Once completed, your account will be ready for login.'
        });
        this.router.navigate(['']);
      }
    });
  }

  isEmailVerify(): boolean {
    return this.router.url.includes("?error=access_denied&error_description=Please%20verify%20your%20email%20before%20logging%20in.");
  }
}
